import { ChangeEventHandler, RefObject } from "react";
import { RefCallBack } from "react-hook-form";
import classNames from "classnames";
import Icon from "../Icon";
import { getUniqueId } from "../../../core/hooks/getUniqueId";
import { isEmpty } from "../../../core/helpers/helpers";

import inputStyles from "./Input.module.css";

export interface TextAreaProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  description?: string;
  validationError?: string | null;
  value?: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  maxSymbols?: number;
  css?: any;
  inputRef?: RefObject<HTMLTextAreaElement> | RefCallBack;
}

/** Represents <textarea /> tag */
export const TextArea = ({
  label = "",
  placeholder = "",
  required = false,
  disabled = false,
  description = "",
  validationError = null,
  value = "",
  onChange = () => {},
  maxSymbols,
  css = {},
  inputRef,
}: TextAreaProps) => {
  const internalValue = value ?? undefined;
  const id = getUniqueId("ta_");
  return (
    <div className={inputStyles.inputContainer}>
      <div className={inputStyles.labelRow}>
        {required && <span className={inputStyles.requiredIcon}>*</span>}
        <label htmlFor={id} className={isEmpty(label) ? "visuallyHidden" : ""}>
          {label || placeholder || description || "textarea"}
        </label>
      </div>
      <div
        className={classNames({
          [inputStyles.inputRow]: true,
          [inputStyles.filledBorder]: !!value,
        })}
      >
        <textarea
          ref={inputRef}
          style={css}
          id={id}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          value={internalValue}
          onChange={(event) =>
            (!maxSymbols || event.target.value.length <= maxSymbols) &&
            onChange(event)
          }
          className={classNames({
            [inputStyles.inputValidationError]: !!validationError,
          })}
        />
        {!!maxSymbols && <p>{`${internalValue?.length}/${maxSymbols}`}</p>}
      </div>
      <div className={inputStyles.description}>{description}</div>
      {validationError ? (
        <div className={inputStyles.validationError}>
          <Icon name="exclamation-circle" size={14} />
          {validationError}
        </div>
      ) : null}
    </div>
  );
};
export default TextArea;
